// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'

class Organization extends Model {
  defaults() {
    return {
      id:   null,
      name: "",
      description:"",
      tag_line: "",
      accreditation: "",
      translations: {es:{},so:{},vi:{},it:{},pt:{}, ru: {},zh:{}},
      preview: false,
      disable_ncsa: false,
      links: [],
      contacts: [],
      addresses: [],
      photos: [],
      payment_methods: [],
      internal_fields: [],
      tracking_fields: [],
      custom_fields_in_use: [],
      agreements: [],
      program_addons: [],
      features: [],
      trials: [],
      disable_ncsa_summary: false,
      disable_ca_summary: false,
      // student_trnsfers: [],
    }
  }
  mutations() {
    return {
      id:   (id) => Number(id) || null,
      preview: Boolean,
    }
  }
  routes() {
    return {
      fetch: '/organizations/{id}',
      save:  '/organizations',
    }
  }

  isPersisted(){
    return !!this.id
  }
  isBlank(){
    return !this.isPersisted()
  }
  can_show(object_type, preview){
   if (preview) return true
   return this.features.includes(object_type)
  }
}

export {
  Organization
}
